import { Button, UnlockIcon, Tooltip } from "melco-ui";
import styled from "styled-components";

const Wrapper = styled.div`
  position: relative;
`;

const BlurredOverlay = styled.div`
  position: absolute;
  left: -3px;
  right: -3px;
  top: -3px;
  bottom: -3px;
  backdrop-filter: blur(2px);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 100;
`;

type LockedFeatureProps = {
  isAllowed: boolean;
  label?: string;
  children: React.ReactNode;
  actionComponent?: React.ReactNode;
};

export const LockedFeature: React.FC<LockedFeatureProps> = ({
  isAllowed,
  children,
  label,
  actionComponent,
}) => {
  return (
    <Wrapper>
      {children}
      {!isAllowed && (
        <BlurredOverlay>
          {actionComponent || (
            <Tooltip title="Access restricted">
              <Button icon={<UnlockIcon />} type="primary">
                {label}
              </Button>
            </Tooltip>
          )}
        </BlurredOverlay>
      )}
    </Wrapper>
  );
};
